import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AffiliateEventRequest, AffiliateRequest, SchemaPointRequest, SchemaPointResponse } from '../models/affiliate.model';

@Injectable({
	providedIn: 'root'
})
export class AffiliateService {
	private url = environment.api + "api/erp/affiliate";
	constructor(
		private http: HttpClient,
	) { }

	getAffiliates() {
		return this.http.get(this.url);
	}

	convertToAffiliate(affiliateId: number, affiliate:AffiliateRequest) {
		return this.http.put(this.url + "/affiliateDes/" + affiliateId, affiliate);
	}

	disposeAffiliate(affiliateId: number, affiliate:AffiliateRequest) {
		return this.http.put(this.url + "/affiliateDispose/" + affiliateId, affiliate);
	}
	
	desactiveEvent(eventId: number) {
		return this.http.put(this.url + "/desactiveEvent/" + eventId, null);
	}

	newAffiliate(newAffiliate: AffiliateRequest) {
		return this.http.post(this.url + "/newAffiliate", newAffiliate);
	}

	editAffiliate(affiliateId: number, affiliate: AffiliateRequest) {
		return this.http.put(this.url + "/editAffiliate/"+affiliateId, affiliate);
	}

	getSchemaPoints(){
		return this.http.get(this.url + "/schemaPoint");
	}

	addSchemaPoints(newSchema: SchemaPointRequest) {
		return this.http.post(this.url + "/schemaPoint", newSchema);
	}

	addEvent(newEvent: AffiliateEventRequest) {
		return this.http.post(this.url + "/event", newEvent);
	}

	updateSchemaPoint(){
		return this.http.put(this.url + "/schemaPoint", null);
	}

	getEvents(){
		return this.http.get(this.url + "/event");
	}
}